import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { DashboardParamsModel } from '../components/main/dashboard-params-model';
import { Globals } from '../globals/Globals';
import { isUndefined } from 'util';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { HttpService } from './http.service';

@Injectable()
export class DashboardDataService {
  static dashboardData;
  static dashboardParams: DashboardParamsModel;

  dataSubject = new Subject();
  paramsSubject = new Subject();
  loading = new Subject<boolean>();

  constructor(
    private cookiesService: CookieService,
    private uploadFileService: HttpService,
  ) {}

  loadParamsAndData() {
    DashboardDataService.dashboardParams = this.loadParams();
    if (!isUndefined(DashboardDataService.dashboardParams)) {
      this.reloadData();
    } else {
      this.uploadFileService
        .getDefaultDashboardParams()
        .subscribe((data: any) => {
          if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
            DashboardDataService.dashboardParams = data.payload;
            this.reloadData();
          }
        });
    }
  }

  public getDDSubscriber(): Observable<Object> {
    return this.dataSubject.asObservable();
  }

  public getLoadingState(): Observable<boolean>{
    return this.loading.asObservable();
  }

  public getDD(whoAsked) {
    console.log('stats called by:', whoAsked);
    if (isUndefined(DashboardDataService.dashboardData)) {
      this.loadParamsAndData();
    } else {
      this.reloadData();
    }
  }

  setDashboardParams(queryParams: DashboardParamsModel) {
    DashboardDataService.dashboardParams = queryParams;
    this.cookiesService.set(
      Globals.COOKIES_DASHBOARD_PARAMS,
      JSON.stringify(DashboardDataService.dashboardParams),
    );
  }

  getParamsSubscriber(): Observable<Object> {
    return this.paramsSubject.asObservable();
  }

  getParams() {
    DashboardDataService.dashboardParams = this.loadParams();
    if (!isUndefined(DashboardDataService.dashboardParams)) {
      this.paramsSubject.next(DashboardDataService.dashboardParams);
      return;
    } else {
      this.uploadFileService
        .getDefaultDashboardParams()
        .subscribe((data: any) => {
          if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
            DashboardDataService.dashboardParams = data.payload;
            this.paramsSubject.next(DashboardDataService.dashboardParams);
          }
        });
      return;
    }
  }

  private loadParams() {
    if (!isUndefined(DashboardDataService.dashboardParams)) {
      return DashboardDataService.dashboardParams;
    }
    const params = this.cookiesService.get(Globals.COOKIES_DASHBOARD_PARAMS);
    if (isUndefined(params) || params.trim() === '') {
      return undefined;
    }
    return JSON.parse(params);
  }

  private reloadData() {
    this.loading.next(true);

    if (!isUndefined(DashboardDataService.dashboardData)){
      //this.paramsSubject.next(DashboardDataService.dashboardParams);
      this.dataSubject.next(DashboardDataService.dashboardData);
      this.loading.next(false);
      return;
    }

    this.uploadFileService
      .getDashboardData(DashboardDataService.dashboardParams)
      .subscribe((data: any) => {
        if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
          DashboardDataService.dashboardData = data.payload;
          this.setDashboardParams(
            DashboardDataService.dashboardData.dashboardRequest,
          );
          // this.paramsSubject.next(DashboardDataService.dashboardParams);
          this.paramsSubject.next(DashboardDataService.dashboardData.dashboardRequest);
          this.dataSubject.next(DashboardDataService.dashboardData);
        }

        this.loading.next(false);
      });
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/services/dashboard-data.service.ts